
import ClickOutside from 'vue-click-outside'
import seo from '~/mixins/seo'
import pwaControl from '~/mixins/pwaControl'

const pageHeadingKeys = {
  login: 'login',
  register: 'register.on_jaty',
  kontakt: 'contact.with_us',
  'password-reset-request': 'account.password.remind',
  'password-reset': 'account.password.remind'
}

const pageSubtitleKeys = {
  login: 'account.login_slogan',
  register: 'register.description_text',
  kontakt: 'contact.slogan'
}

export default {
  mixins: [pwaControl],
  directives: {
    'click-outside': ClickOutside
  },
  computed: {
    pageHeading () {
      const routeName = (this.$route.name || '').split('___')[0]
      const key = pageHeadingKeys[routeName]
      return key ? this.$t(key) : null
    },
    pageSubtitle () {
      const routeName = (this.$route.name || '').split('___')[0]
      const key = pageSubtitleKeys[routeName]
      return key ? this.$t(key) : null
    }
  },
  watch: {
    '$route.path' () {
      this.closeLanguagePicker()
    }
  },
  methods: {
    closeLanguagePicker () {
      if (this.$refs.languagePicker) this.$refs.languagePicker.open = false
    }
  },
  head () {
    const localizedHead = seo.head.call(this)
    return {
      ...localizedHead,
      title: this.$t('title.login_layout'),
      meta: [
        ...localizedHead.meta,
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.login_layout')
        }
      ],
      link: [
        ...localizedHead.link,
        {
          rel: 'preconnect',
          href: 'https://fonts.googleapis.com'
        },
        {
          rel: 'preconnect',
          href: 'https://fonts.gstatic.com'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Nunito&display=swap'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@300;500;600;700&display=swap'
        },
      ]
    }
  },
}

